import {createContext, useContext} from 'react';

import {Handler, Unregistrator} from '../../../libs/shared/helpers/src/react/reactHelpers';

/*
 * Props.
 */

export interface RelativeDateTimeContextProps {
  registerRefresher: (worker: Handler) => Unregistrator;
}

/*
 * Context.
 */

const RelativeDateTimeContext = createContext<RelativeDateTimeContextProps>({
  registerRefresher: () => () => {},
});

export const RelativeDateTimeContextProvider = RelativeDateTimeContext.Provider;

/*
 * Hook.
 */

export function useRelativeDateTime() {
  return useContext(RelativeDateTimeContext);
}
